export const SET_OUTLET_SETTINGS = 'CONTACTLESS.SET_OUTLET_SETTINGS'
